import Header from "../../components/header"
import { Footer } from "../../components/Footer"
import { IftFiles } from "../../components/ift_files"
import { CTASection } from "../../components/CTASection"
import { ReactComponent as ContractIcon } from '../../icons/Contract.svg'
import { ReactComponent as SupportIcon } from '../../icons/support.svg'
import { ReactComponent as PhoneIcon } from '../../icons/telephone.svg'
import './ift.scss'

export default function IFT() {

  const complianceInfo = [
    {
      icon: ContractIcon,
      title: "Regulación IFT",
      description: "Cumplimos con todas las disposiciones del Instituto Federal de Telecomunicaciones para brindar servicios de internet confiables y transparentes."
    },
    {
      icon: SupportIcon,
      title: "Protección PROFECO",
      description: "Nuestros contratos están aprobados por PROFECO, garantizando tus derechos como consumidor y prácticas comerciales justas."
    },
    {
      icon: PhoneIcon,
      title: "Transparencia Total",
      description: "Acceso completo a toda nuestra documentación legal, contratos y tarifas registradas ante las autoridades competentes."
    }
  ]
  
  return (
    <div className="ift-page">
      <Header />
      <main className="ift-content">
        
        <section className="ift-hero">
          <div className="container">
            <div className="hero-content">
              <h1 className="ift-title">Cumplimiento Legal y Transparencia</h1>
              <p className="ift-subtitle">
                Inter Home México cumple con todas las regulaciones de IFT y PROFECO. 
                Conoce nuestros documentos oficiales y constancias de registro.
              </p>
            </div>
          </div>
        </section>

        <section className="compliance-info">
          <div className="container">
            <h2 className="section-title">Nuestro Compromiso Regulatorio</h2>
            <div className="info-grid">
              {complianceInfo.map((info, index) => (
                <div key={index} className="info-card">
                  <div className="info-icon-wrapper">
                    <info.icon className="info-icon" />
                  </div>
                  <h3 className="info-title">{info.title}</h3>
                  <p className="info-description">{info.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="documents-section">
          <div className="container">
            <div className="documents-header">
              <h2 className="section-title">Documentos Oficiales</h2>
              <p className="documents-subtitle">
                Descarga y consulta todos nuestros documentos oficiales registrados ante IFT y PROFECO
              </p>
            </div>
            
            <div className="documents-grid">
              <IftFiles />
            </div>

          </div>
        </section>

        <CTASection />
        
      </main>
      <Footer />
    </div>
  )
}
